import { Injectable} from '@angular/core';
import { HttpClient} from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class OSFService {
    summeryData: any;
    constructor(private http: HttpClient) { }
    orderStatusFilter( acctRef, params, serviceUrl) {
        let timeNow = Date.now();
        return this.http.get(serviceUrl + '/trading/' + acctRef + '/orders' + '?time=' + timeNow, { params });
    }
    getDetailedOrderStatus(serviceUrl, acctRef, ordDtlKey, params) {
        let timeNow = Date.now();
        return this.http.get(serviceUrl + '/trading/' + acctRef + '/order/' + ordDtlKey + '/details?' + '?time=' + timeNow , { params });
    }
}
